import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FlexFieldConfig } from './flex-field.model';

@Injectable({
  providedIn: 'root'
})
export class FlexFieldService {
  private baseUrl = `${environment.restApiUrl}flex-fields-config`;

  constructor(private http: HttpClient) {}

  getConfigs(businessObject: string, owningCompanyId?: number): Observable<FlexFieldConfig[]> {
    let params = new HttpParams();
    if (owningCompanyId != null) {
      params = params.set('owningCompanyId', owningCompanyId.toString());
    }
    return this.http.get<FlexFieldConfig[]>(`${this.baseUrl}/${businessObject}`, { params });
  }

  getAllConfigs(owningCompanyId?: number): Observable<FlexFieldConfig[]> {
    let params = new HttpParams();
    if (owningCompanyId != null) {
      params = params.set('owningCompanyId', owningCompanyId.toString());
    }
    return this.http.get<FlexFieldConfig[]>(this.baseUrl, { params });
  }

  saveConfigs(businessObject: string, configs: FlexFieldConfig[], owningCompanyId?: number): Observable<FlexFieldConfig[]> {
    let params = new HttpParams();
    if (owningCompanyId != null) {
      params = params.set('owningCompanyId', owningCompanyId.toString());
    }
    return this.http.put<FlexFieldConfig[]>(`${this.baseUrl}/${businessObject}`, configs, { params });
  }
}
